import genInitState from '../core/initState';

export default genInitState();
